import React from "react";
import { CardContent } from "@material-ui/core";
import Swal from "sweetalert2";
// import { makeStyles } from "@material-ui/core/styles";
import "./cardcompra.css";

import { domain } from "../../../Urls/Services/Api_urls";
import { ModernTv, Wifi, Cart, Phone, DataTransferBoth } from "iconoir-react";
function CardcomprasinInit(props) {

  const precio = props.precio_persona;
  const estrat = props.estratoview === "1-3" ? 1 : 5;
  const estratoviews = props.estratoview === "1-3" ? "1,2,3" : "4,5,6";
  const calling = () => {
    Swal.fire({
      title: `${props.nombreplan}`,
      html: ` 
              
                    
                      <label style="display: block; width: 70%; margin: 0.5rem auto 0; text-align: left; font-weight: 500;">Nombre *</label>
                      <input id="nombre" class="swal2-input" placeholder="Nombre *" style="width: 70%; margin: 0.3rem auto 0.5rem; border: 1px solid;">
                      <label style="display: block; width: 70%; margin: 0.5rem auto 0; text-align: left; font-weight: 500;">Apellido *</label>
                      <input id="apellido" class="swal2-input" placeholder="Apellido *" style="width: 70%; margin: 0.3rem auto 0.5rem; border: 1px solid;">
                      <label style="display: block; width: 70%; margin: 0.5rem auto 0; text-align: left; font-weight: 500;">Telefono *</label>
                      <input id="telefono" class="swal2-input" placeholder="Telefono *" style="width: 70%; margin: 0.3rem auto 0.5rem; border: 1px solid;">
                      <label style="display: block; width: 70%; margin: 0.5rem auto 0; text-align: left; font-weight: 500;">Correo electronico *</label>
                      <input id="mail" class="swal2-input" placeholder="Correo electronico *" style="width: 70%; margin: 0.3rem auto 0.5rem; border: 1px solid;">
                      <label style="display: block; width: 70%; margin: 0.5rem auto 0; text-align: left; font-weight: 500;">Dirección *</label>
                      <input id="direccion" class="swal2-input" placeholder="Dirección *" style="width: 70%; margin: 0.3rem auto 0.5rem; border: 1px solid;">
                      <label style="display: block; width: 70%; margin: 0.5rem auto 0; text-align: left; font-weight: 500;">Barrio *</label>
                      <input id="neighborhood" class="swal2-input" placeholder="Barrio" style="width: 70%; margin: 0.3rem auto 0.5rem; border: 1px solid;">
                      <label style="display: block; width: 70%; margin: 0.5rem auto 0; text-align: left; font-weight: 500;">Ciudad *</label>
                      <select class="select swal2-input" id="mySelectElement" style="width: 70%; height: 3.4rem; margin: 0.3rem auto 1rem; border: 1px solid;">
                        <option value="Cali">Cali</option>
                        <option value="Jamundi">Jamundi</option>
                        <option value="Yumbo">Yumbo</option>
                        <option value="Candelaria">Candelaria</option>
                        <option value="Puerto tejaada">Puerto tejaada</option>
                        <option value="Palmira">Palmira</option>
                     </select>
                      `,

      confirmButtonColor: "#4a1272",
      confirmButtonText: "Enviar",
      showCloseButton: true,
      focusConfirm: false,
      preConfirm: () => {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
          name: document.getElementById("nombre").value,
          last_name: document.getElementById("apellido").value,
          phone: document.getElementById("telefono").value,
          address: document.getElementById("direccion").value,
          mail: document.getElementById("mail").value,
          neighborhood: document.getElementById("neighborhood").value,
          city: document.getElementById("mySelectElement").value,
          service: props.nombreplan,
        });

        var requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        return fetch(domain + "/portal/out/", requestOptions)
          .then((response) => {
            // Intenta convertir la respuesta en JSON
            return response.json().then((data) => {
              if (!response.ok) {
                // Si la respuesta no es OK, lanza un error con el mensaje devuelto
                const errorMsg = data.msg || response.statusText;
                throw new Error(errorMsg);
              }
              // Si todo va bien, muestra el mensaje de éxito
              Swal.fire({
                icon: "success",
                title: "Perfecto!",
                text: "Nos contactaremos contigo muy pronto!",
              });
            });
          })
          .catch((error) => {
            // Imprime el mensaje de error en la consola
            console.error(error.message);
            // Muestra el mensaje de error en la validación de Swal
            Swal.showValidationMessage(`Hay errores en el formulario, ${error.message}`);
          });
      },
    });
  };

  const fun = () => {
    props.funcion(props);
  };

  const icons_change = (tipoplan) => {
    if (tipoplan === "Triple") {
      return (
        <>
          <b
            style={{
              display: "flex",
              justifyContent: "flex-start",
              padding: "1.5rem",
            }}
          >
            Incluye
          </b>
          <div
            className="rd"
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "flex-start",
              gap: "10px",
              height: "3rem",
            }}
          >
            <div className="rt">
              <div className="telefonia" style={{ display: "none" }}>
                <div>
                  <span className="minutos-incluidos">ilimitados</span>
                  minutos a destinos fijos locales
                </div>
              </div>
              <Phone
                className="icono-telefonia"
                style={{ width: "70%", height: "60%", marginBottom: "4px" }}
                alt="Telefonia"
              />
            </div>
            <div>
              <b>Fija local ilimitada</b>
            </div>
          </div>
          <div
            className="rd"
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "flex-start",
              gap: "10px",
              height: "3rem",
            }}
          >
            <div className="rt">
              <div className="internet" tecnologia="108" style={{ display: "none" }}>
                <div>
                  Internet de
                  <span className="velocidad-bajada">{props.velocidad}</span>
                  Mbps de bajada
                </div>
                <div>
                  Internet de
                  <span className="velocidad-subida">{props.velocidad}</span>
                  Mbps de subida
                </div>
              </div>
              <Wifi
                className="Internet"
                style={{ width: "70%", height: "60%", marginBottom: "4px" }}
                alt="Internet"
                tecnologia="108"
              />
            </div>
            <div className="velocidad-bajada" style={{ display: "none" }}>
              {props.velocidad} Megas
            </div>

            <div className="velocidad-subida">{props.velocidad} Megas</div>
          </div>
          <div
            className="rd"
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "flex-start",
              gap: "10px",
              height: "3rem",
            }}
          >
            <div className="rt">
              <div
                className="television"
                tecnologia="3"
                style={{ display: "none" }}
              >
                <span className="canales-hd">48</span> canales HD
              </div>
              <ModernTv
                className="icono-television"
                style={{ width: "70%", height: "60%", marginBottom: "4px" }}
                alt="Television"
                tecnologia="3"
              />
            </div>
            <div className="canales-hd" style={{ display: "none" }}>
              48 Canales
            </div>
            <div className="canales-sd" style={{ display: "none" }}>
              65 Canales
            </div>
            <div>
              <b>113 canales</b>
            </div>
          </div>
        </>
      );
    } else if (tipoplan === "Dupla") {
      return (
        <>
          <b
            style={{
              display: "flex",
              justifyContent: "flex-start",
              padding: "1.5rem",
            }}
          >
            Incluye
          </b>

          <div
            className="rd"
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "flex-start",
              gap: "10px",
              height: "3rem",
            }}
          >
            <div className="rt">
              <div className="telefonia" style={{ display: "none" }}>
                <div>
                  <span className="minutos-incluidos">ilimitados</span>
                  minutos a destinos fijos locales
                </div>
              </div>
              <Phone
                className="icono-telefonia"
                style={{ width: "70%", height: "60%", marginBottom: "4px" }}
                alt="Telefonia"
              />
            </div>
            <div>
              <b>Fija local ilimitada</b>
            </div>
          </div>
          <div
            className="rd"
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "flex-start",
              gap: "10px",
              height: "3rem",
            }}
          >
            <div className="rt">
              <div className="internet" tecnologia="108" style={{ display: "none" }}>
                <div>
                  Internet de
                  <span className="velocidad-bajada">{props.velocidad}</span>
                  Mbps de bajada
                </div>
                <div>
                  Internet de
                  <span className="velocidad-subida">{props.velocidad}</span>
                  Mbps de subida
                </div>
              </div>
              <Wifi
                className="Internet"
                style={{ width: "70%", height: "60%", marginBottom: "4px" }}
                alt="Internet"
                tecnologia="108"
              />
            </div>
            <div className="velocidad-bajada" style={{ display: "none" }}>
              {props.velocidad} Megas
            </div>

            <div className="velocidad-subida">{props.velocidad} Megas</div>
          </div>
        </>
      );
    } else if (tipoplan === "Doble") {
      return (
        <>
          <b
            style={{
              display: "flex",
              justifyContent: "flex-start",
              padding: "1.5rem",
            }}
          >
            Incluye
          </b>
          <div
            className="rd"
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "flex-start",
              gap: "10px",
              height: "3rem",
            }}
          >
            <div className="rt">
              <div className="telefonia" style={{ display: "none" }}>
                <div>
                  <span className="minutos-incluidos">ilimitados</span>
                  minutos a destinos fijos locales
                </div>
              </div>
              <Phone
                className="icono-telefonia"
                style={{ width: "70%", height: "60%", marginBottom: "4px" }}
                alt="Telefonia"
              />
            </div>
            <div>
              <b>Fija local ilimitada</b>
            </div>
          </div>
          <div
            className="rd"
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "flex-start",
              gap: "10px",
              height: "3rem",
            }}
          >
            <div className="rt">
              <div
                className="television"
                tecnologia="3"
                style={{ display: "none" }}
              >
                <span className="canales-hd">48</span> canales HD
              </div>
              <ModernTv
                className="icono-television"
                style={{ width: "70%", height: "60%", marginBottom: "4px" }}
                alt="Television"
                tecnologia="3"
              />
            </div>
            <div className="canales-hd" style={{ display: "none" }}>
              48 Canales
            </div>
            <div className="canales-sd" style={{ display: "none" }}>
              65 Canales
            </div>
            <div>
              <b>113 canales</b>
            </div>
          </div>
        </>
      );
    } else if (tipoplan === "Internet") {
      return (
        <>
          <b
            style={{
              display: "flex",
              justifyContent: "flex-start",
              padding: "1.5rem",
            }}
          >
            Incluye
          </b>
          <div
            className="rd"
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "flex-start",
              gap: "10px",
              height: "3rem",
            }}
          >
            <div className="rt">
              <div className="internet" tecnologia="108" style={{ display: "none" }}>
                <div>
                  Internet de
                  <span className="velocidad-bajada">{props.velocidad}</span>
                  Mbps de bajada
                </div>
                <div>
                  Internet de
                  <span className="velocidad-subida">{props.velocidad}</span>
                  Mbps de subida
                </div>
              </div>
              <Wifi
                className="icono-internet"
                style={{ width: "70%", height: "60%", marginBottom: "4px" }}
                alt="Internet"
                tecnologia="108"
              />
            </div>
            <div className="velocidad-bajada" style={{ display: "none" }}>
              {props.velocidad} Megas
            </div>
            <div className="velocidad-subida">{props.velocidad} Megas</div>
          </div>
        </>
      );
    }
  };


  return (
    <div
      className="card-entry-hover flex justify-center items-center flex-col mt-2 mb-2 shadow-md bg-white border-transparent rounded-xl"
    >
      <div>
        <div
          className="plan pospago"
          dane="76001,76520,76892,76130,76364"
          valor-numerico={parseInt(precio[estrat])}
          estrato={estratoviews}
          titulo={props.nombreplan}
        >
          <div className="operador" operador-nit="890399003" style={{ display: "none" }}>EMCALI</div>
          <img className="operador-logo" src="https://c748596267.imgdist.com/pub/bfra/zs95jvh4/uy4/tyz/u0a/logo_emcali.png" alt="EMCALI" style={{ display: "none" }} />
          <div className="url-comercial" style={{ display: "none" }}>
            https://portalservicios.emcali.net.co/planes
          </div>

          <div className="caracteristica-adicional">
            <h6 className="mt-3">Plan residencial</h6>
          </div>
          <CardContent key={props.id} style={{ paddingTop:"8px" }}>
            <div style={{ padding: "0" }}>
              <h2 style={{ fontSize: "30px" }}>
                <b className="text-colorprimary inline-flex justify-center"
                >
                  {" "}
                  {props.velocidad} Megas
                  <DataTransferBoth style={{ width: "10%" }} />
                </b>
              </h2>
            </div>
            <div
              className="valor card-title pricing-card-title"
              valor-numerico={parseInt(precio[estrat])}
            >
              <h6>Estrato {props.estratoview}</h6>
              <br></br>
              <h5 style={{ fontSize: "24px" }}>
                <b>
                  {new Intl.NumberFormat("es-CO", {
                    style: "currency",
                    currency: "COP",
                    minimumFractionDigits: 0,
                  }).format(Math.trunc(precio[estrat]))}
                </b>
                <h6>Mensual</h6>
              </h5>
            </div>
            <div className="mt-[3.4rem]"></div>
            <div className="row">{icons_change(props.tipoplan)}</div>
            <div className="flex justify-center items-center">
              <button className="action-button buy-button" onClick={() => fun()}>
                <Cart className="icon" style={{}} />
                <b>{props.nombreButton}</b>
              </button>
            </div>
            <div className="flex justify-center items-center mt-2" style={{ display: props.display }}>
              <button
                className="action-button phone-button"
                onClick={() => {
                  calling();
                }}
              >
                <Phone className="icon" style={{}} />
                <b>Te asesoramos</b>
              </button>
            </div>
          </CardContent>
        </div>
      </div>
    </div>
  );
}

export default CardcomprasinInit;
